
import { useState, useEffect, useContext } from 'react';
import { unauthenticate } from 'cognito/auth';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

function Logout () 
{
    const { onLoggedOut } = useContext ( CurrentUserContext );

    const [ isLoaded, setIsLoaded ] = useState ( false );
    const [ result, setResult ] = useState ( null );

    const doLogout = async () => {

        const result = await unauthenticate ();

        setIsLoaded ( true );
        setResult ( result );
        onLoggedOut ();
    }
   
    useEffect ( () => {

        if ( result === null && isLoaded === false )
        {
            doLogout ();
        }

    } );

    if ( isLoaded === false )
    {
        return <>
                <h1>Logout</h1>
                <p>You are being logged out...</p>
            </>
    }
    else
    {
        return <>
                <h1>Logged Out</h1>
                <p>You have been logged out.</p>
            </>
    }
}

export default Logout;
